var React = require('react');

function IconDeploy (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M828.4 553.5c1.7-13.3 3-26.6 3-40.7s-1.3-27.4-3-40.7l90.1-68.6c8.1-6.2 10.3-17.4 5.1-26.6l-85.4-143.7c-5.1-9.1-16.7-12.5-26.1-9.1l-106.4 41.5c-22.2-16.6-46.1-30.3-72.2-40.7l-16.2-110.1c-1.3-10-10.3-17.4-20.9-17.4H425.6c-10.7 0-19.6 7.5-20.9 17.4l-16.2 110.1c-26.1 10.4-50 24.5-72.2 40.7L209.9 224c-9.8-3.7-20.9 0-26.1 9.1L98.4 376.9c-5.6 9.1-3 20.4 5.1 26.6l90.1 68.6c-1.7 13.3-3 27-3 40.7 0 13.7 1.3 27.4 3 40.7L103.5 622c-8.1 6.2-10.3 17.4-5.1 26.6l85.4 143.7c5.1 9.1 16.7 12.5 26.1 9.1L316.2 760c22.2 16.6 46.1 30.3 72.2 40.7l16.2 110.1c1.3 10 10.2 17.4 20.9 17.4h170.8c10.7 0 19.6-7.5 20.9-17.4l16.2-110.1c26.1-10.4 50-24.5 72.2-40.7L812 801.5c9.8 3.7 20.9 0 26.1-9.1l85.4-143.7c5.1-9.1 3-20.4-5.1-26.6l-90-68.6zm-488.3-42.7c0-95.5 77.7-173.1 173.1-173.1 95.5 0 173.1 77.7 173.1 173.1s-77.7 173.1-173.1 173.1c-95.5 0-173.1-77.7-173.1-173.1z"}));
}

IconDeploy.displayName = "IconDeploy";

IconDeploy.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconDeploy;

IconDeploy.default = IconDeploy;
